// Consent Component (Vanilla JS version)
//
// Manages Shopify consent tracking and Google Tag Manager integration.
// Usage:
// const consent = new Consent();
// consent.init();

class Consent {
  constructor() {
    this.init = this.init.bind(this);
    this.handleConsentUpdate = this.handleConsentUpdate.bind(this);
    this.checkConsentBannerInteraction = this.checkConsentBannerInteraction.bind(this);
    this.gtag = this.gtag.bind(this);
    this.recallConsent = this.recallConsent.bind(this);
  }

  async init() {
    if (!window.Shopify || !window.Shopify.loadFeatures) {
      console.error('Shopify object or loadFeatures not available.');
      return;
    }

    window.Shopify.loadFeatures(
      [
        {
          name: 'consent-tracking-api',
          version: '0.1',
        },
      ],
      (error) => {
        if (error) {
          console.error('Error loading features: ', error);
          return;
        }
        console.log('Consent tracking API loaded');
        this.initConsentComponent();
      }
    );
  }

  async initConsentComponent() {
    window.dataLayer = window.dataLayer || [];

    document.addEventListener('visitorConsentCollected', async () => {
      this.handleConsentUpdate('update');
    });

    const recallConsentElement = document.getElementById('recall-consent');
    if (recallConsentElement) {
      recallConsentElement.addEventListener('click', (event) => {
        event.preventDefault();
        this.recallConsent();
      });
    }
  }

  async handleConsentUpdate(state) {
    if (!window.Shopify || !window.Shopify.customerPrivacy || !window.Shopify.customerPrivacy.currentVisitorConsent) {
      console.error('Shopify consent API not available');
      return;
    }

    const visitorConsent = await window.Shopify.customerPrivacy.currentVisitorConsent();

    const consent = {
      functionality_storage: 'granted',
      analytics_storage: visitorConsent.analytics === 'yes' ? 'granted' : 'denied',
      personalization_storage: visitorConsent.analytics === 'yes' ? 'granted' : 'denied',
      ad_storage: visitorConsent.marketing === 'yes' ? 'granted' : 'denied',
      ad_user_data: visitorConsent.marketing === 'yes' ? 'granted' : 'denied',
      ad_personalization: visitorConsent.marketing === 'yes' ? 'granted' : 'denied',
      wait_for_update: 3000,
    };

    this.gtag('consent', state, consent);

    try {
      localStorage.setItem('consentSettings', JSON.stringify(consent));
    } catch (err) {
      console.warn('Could not persist consent settings:', err);
    }
  }

  async checkConsentBannerInteraction() {
    if (!window.Shopify || !window.Shopify.customerPrivacy || !window.Shopify.customerPrivacy.currentVisitorConsent) {
      return false;
    }

    const visitorConsent = await window.Shopify.customerPrivacy.currentVisitorConsent();
    return !(visitorConsent.preferences === '' && visitorConsent.analytics === '' && visitorConsent.marketing === '');
  }

  gtag() {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(arguments);
  }

  async recallConsent() {
    if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
      window.privacyBanner.showPreferences();
    } else {
      console.warn('Privacy banner not available to recall preferences.');
    }
  }
}

// Export as global variable if needed
// window.Consent = Consent;